import React from 'react';
import './CardButton.css';
import { directDeepLink, SOURCE_HOME } from '../../../util';
import { useHistory } from 'react-router-dom';


function CardButton(props) {
	// alert(props.background)
	let history = useHistory();


	const { text, subtext, className, deeplink, navigate, eventCallback=null} = props;
	return (
		<button className={className} onClick={() => {
			// window?.mobile?.onDeeplinkExecutedV2(JSON.stringify(deeplink));
			if(typeof eventCallback === "function") {
				eventCallback();
			}
			deeplink && directDeepLink(deeplink, SOURCE_HOME);
			navigate && history.push(navigate)}}>{text}

			{subtext && (
				<span className='card-btn-subtext'>{subtext}</span>
			)}

		</button>
	);
}
CardButton.defaultProps = {
	deeplink:'',
	subtext:'',
  }
export default CardButton;
